import React, { memo, useCallback } from 'react';

import { Button } from 'antd';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import pageUrls from '@/constants/pageUrls';
import Alert, { ALERT_TYPE } from '@/views/alerts/Alert';

const CompanyVerifySuccessed = props => {
  const { action = true } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const handleClickButton = useCallback(() => {
    history.push(pageUrls.CONTRACT);
  }, [history]);

  return (
    <Alert
      type={ALERT_TYPE.SUCCESS}
      message={t('alert.company-verify-successed.title')}
      description={t('alert.company-verify-successed.description')}
      action={
        action && (
          <Button shape="round" type="primary" onClick={handleClickButton}>
            {t('alert.company-verify-successed.button')}
          </Button>
        )
      }
    />
  );
};

export default memo(CompanyVerifySuccessed);
